import React, {useEffect, useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import Icon from '../../components/Icon';
import Query from '../../components/Query';
import Avatar from '../../components/Avatar';
import {QUERY_USER} from '../Client/graphql';
import {MUTATION_LETTER_SAVE, QUERY_LETTER_LIST} from './graphql';
import {updateCreate} from '../../utils/mutation';

const LetterList = ({talkId}) => {
  const {user} = useQuery(QUERY_USER).data;

  const [content, setContent] = useState('');

  const variables = {talkId, talkNull: talkId ? undefined : true};

  const query = useQuery(QUERY_LETTER_LIST, {variables});
  const letters = query.data ? query.data.letterList : [];

  useEffect(() => {
    query.startPolling(3000);

    return () => {
      query.stopPolling();
    };
  }, []);

  const [save, saveResp] = useMutation(MUTATION_LETTER_SAVE, {
    update: (cache, response) => {
      updateCreate(cache, response, {
        query: QUERY_LETTER_LIST,
        variables,
        getTarget: (target, item) => [item, ...target],
      });
    },
    onCompleted: data => {
      if (data.letterSave.obj) {
        setContent('');
      }
    },
  });

  return (
    <div className="LetterList h-100 d-flex flex-column">
      <div className="col overflow-auto">
        {Query(query) || (
          <div className="p-3" style={{transform: `rotate(-180deg)`}}>
            {letters.map((item, index) => {
              const isMe = item.talkId ? user.client.id === item.client.id : !item.isAdmin;
              const isPreviousUser =
                letters[index - 1] &&
                (item.talkId
                  ? letters[index - 1].client.id === item.client.id
                  : letters[index - 1].isAdmin === item.isAdmin);
              const isNextUser =
                letters[index + 1] &&
                (item.talkId
                  ? letters[index + 1].client.id === item.client.id
                  : letters[index + 1].isAdmin === item.isAdmin);
              const contentStyle = {
                backgroundColor: isMe ? '#eaeaea' : '#cbe6f6',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: isMe ? '#e2e1e1' : '#b5d5e7',
                color: isMe ? '#282424' : '#210000',
              };

              return (
                <div
                  className={`row align-items-start ${isMe && 'justify-content-end'} mb-${!isNextUser ? '3' : '1'}`}
                  style={{transform: `rotate(-180deg)`}}
                  key={item.id}
                >
                  <div style={{width: '100%'}}>
                    {!isNextUser && (
                      <div className={`row align-items-center ${isMe && 'justify-content-end'} mb-1`}>
                        <div className="col-auto">
                          <Avatar user={item.client.user} size={30} bubble={isMe ? 'top-left' : 'top-right'} />
                        </div>
                        <div className={`col ${isMe ? 'order-first me-2 text-end' : 'ms-2'}`}>
                          <div>{item.isAdmin ? 'Arine.kz' : item.client.user.fullname}</div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={`col mx-1 d-flex flex-column ${isMe ? 'align-items-end' : 'align-items-start'}`}>
                    <div
                      className="px-3 py-1"
                      style={{
                        ...contentStyle,
                        maxWidth: '75%',
                        minHeight: 30,
                        lineHeight: '130%',
                        display: 'inline-block',
                        borderTopLeftRadius: !isNextUser ? (!isMe ? 0 : 25) : !isMe ? 5 : 25,
                        borderTopRightRadius: !isNextUser ? (isMe ? 0 : 25) : !isMe ? 25 : 5,
                        borderBottomLeftRadius: !isPreviousUser ? 25 : !isMe ? 5 : 25,
                        borderBottomRightRadius: !isPreviousUser ? 25 : !isMe ? 25 : 5,
                      }}
                    >
                      <div>{item.content}</div>
                      {/*<span className="font-2 text-muted ms-3">{moment(item.createdAt).format('HH:mm')}</span>*/}
                    </div>
                  </div>
                  {isMe && !letters[index - 1] && (
                    <div className="font-2 text-muted mt-4 text-center px-4">
                      Оператор обрабатывает вопросы в определённые времена. После ответа вы получите уведомление на
                      почту
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="row align-items-end gx-3 px-3 pb-3">
        <div className="col">
          <textarea
            value={content}
            onChange={e => setContent(e.target.value)}
            cols="1"
            className="form-control"
            placeholder="Отправьте сообщение"
            wrap="soft"
          />
        </div>
        <div className="col-auto">
          <button
            onClick={() => save({variables: {input: {content, talk: talkId}}})}
            disabled={saveResp.loading}
            className="btn btn-primary"
          >
            <Icon name="send" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LetterList;
